export default "__VITE_ASSET__oGF6mqOH__"